import React from "react";

interface IconProps {
  size?: number;
  color?: string;
}

const ArrowBackIcon: React.FC<IconProps> = ({ 
  size = 24, 
  color = "currentColor" 
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z"
        fill={color}
      />
    </svg>
  );
};

export default ArrowBackIcon;